import * as React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { default as defaultTheme, cjkTheme } from './theme';
import { jsx as _jsx } from "react/jsx-runtime";
const MuiV4ThemeProvider = ({
  children,
  options = {}
}) => {
  const theme = React.useMemo(() => {
    var _options$lang;
    return options.theme || ((_options$lang = options.lang) !== null && _options$lang !== void 0 && _options$lang.includes('zh') ? cjkTheme : defaultTheme);
  }, [options]);
  return _jsx(MuiThemeProvider, {
    theme: theme,
    children: children
  });
};
export default MuiV4ThemeProvider;